
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZDialogGeneric',
  data() {
    return {
      showInternal: false
    }
  },
  mounted() {
    this.showInternal = true
    document.addEventListener('keyup', this.handleKeyup)
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.handleKeyup)
  },
  methods: {
    handleBackdropClick(event: MouseEvent): void {
      if (event.target === event.currentTarget && !this.preventClose) {
        this.close()
      }
    },
    close(): void {
      this.showInternal = false
      setTimeout(() => {
        this.$emit('onClose')
      }, 200)
    },
    handleKeyup(e: KeyboardEvent): void {
      if (e.key === 'Escape') {
        this.close()
      }
    }
  },
  props: {
    transparent: {
      type: Boolean,
      default: false
    },
    preventClose: {
      type: Boolean,
      default: false
    }
  }
})
